import PageHeader from "@/components/site/PageHeader";
import { BLOG_POSTS } from "@/data/site";

export default function Blog() {
  return (
    <main data-testid="blog-page">
      <PageHeader
        overline="Insights"
        title="Field notes from our engineering, product and AI teams"
        subtitle="Patterns, playbooks and points-of-view we've earned from shipping production systems for serious operators."
        testid="blog-page-header"
      />

      <section className="py-12 md:py-16">
        <div className="container-zx grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {BLOG_POSTS.map((p) => (
            <article key={p.title} className="card-surface overflow-hidden" data-testid={`blog-card-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 60)}`}>
              <div className="relative aspect-[16/9] overflow-hidden">
                <img src={p.image} alt={p.title} className="absolute inset-0 h-full w-full object-cover opacity-90" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2D] via-transparent to-transparent" />
                <div className="absolute top-3 left-3 chip bg-[#071A2D]/70 backdrop-blur">{p.category}</div>
              </div>
              <div className="p-6">
                <div className="text-[11px] tracking-[0.2em] uppercase text-ink-400">{p.date} · {p.read} read</div>
                <h3 className="mt-2 font-display text-lg font-semibold text-white leading-snug">{p.title}</h3>
                <p className="mt-2 text-sm text-ink-400 line-clamp-3">{p.excerpt}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
